import { useLayoutEffect, useState } from 'react'

interface UseIsOverflowParams {
  ref: React.RefObject<HTMLElement>
  callback?: (isOverflow: boolean) => void
  overflowType?: 'height' | 'width'
}
const overFlowTypes = {
  height: { scroll: 'scrollHeight', client: 'clientHeight' },
  width: { scroll: 'scrollWidth', client: 'clientWidth' },
}

export const useIsOverflow = ({ ref, callback, overflowType = 'height' }: UseIsOverflowParams) => {
  const [isOverflow, setIsOverflow] = useState(false)

  useLayoutEffect(() => {
    const { current } = ref

    if (current) {
      if (!current) {
        setIsOverflow(false)
        if (callback) callback(false)
      } else {
        const hasOverflow =
          (current as HTMLElement & Record<string, any>)[overFlowTypes[overflowType].scroll] >
          (current as HTMLElement & Record<string, any>)[overFlowTypes[overflowType].client]

        setIsOverflow(hasOverflow)
        if (callback) callback(hasOverflow)
      }
    }
  }, [callback, overflowType, ref])

  return isOverflow
}
